// Example data shared by the component specimens and the home page.

export type OfficeRow = { id: string; office: string; state: string; wait: number; status: string }
export const offices: OfficeRow[] = [
  { id: 'a', office: 'Anchorage Field Office', state: 'Alaska', wait: 12, status: 'Open' },
  { id: 'b', office: 'Baltimore Service Center', state: 'Maryland', wait: 4, status: 'Open' },
  { id: 'c', office: 'Chicago Federal Building', state: 'Illinois', wait: 21, status: 'Limited' },
  { id: 'd', office: 'Denver Regional Office', state: 'Colorado', wait: 8, status: 'Open' },
  { id: 'e', office: 'El Paso Port Office', state: 'Texas', wait: 16, status: 'Open' },
  { id: 'f', office: 'Fargo Field Office', state: 'North Dakota', wait: 3, status: 'Closed' },
]

export const officeColumns = [
  { key: 'office' as const, label: 'Office' },
  { key: 'state' as const, label: 'State' },
  { key: 'wait' as const, label: 'Wait (days)', numeric: true },
  { key: 'status' as const, label: 'Status' },
]

/** A longer list, so the data table example has pages. */
export const allOffices: OfficeRow[] = [
  ...offices,
  { id: 'g', office: 'Grand Rapids Field Office', state: 'Michigan', wait: 9, status: 'Open' },
  { id: 'h', office: 'Honolulu Service Center', state: 'Hawaii', wait: 14, status: 'Open' },
  { id: 'i', office: 'Indianapolis Federal Center', state: 'Indiana', wait: 6, status: 'Limited' },
  { id: 'j', office: 'Jackson Field Office', state: 'Mississippi', wait: 11, status: 'Open' },
  { id: 'k', office: 'Kansas City Regional Office', state: 'Missouri', wait: 18, status: 'Open' },
  { id: 'l', office: 'Louisville Service Center', state: 'Kentucky', wait: 5, status: 'Closed' },
]
